import PropTypes from 'prop-types'
import React from 'react'

const SpinLoader = ({ ui }) => (
  <div className={`loader ${ui.fetching ? 'loader--active' : ''}`}>
    <div className="loader__spinner" data-cy="spinloader" />
  </div>
)

SpinLoader.defaultProps = {
  ui: {},
}

SpinLoader.propTypes = {
  ui: PropTypes.object,
}

export default SpinLoader
